var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"tab",class:{'tab--active': _vm.isActive},attrs:{"type":"button","disabled":_vm.isActive},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._v(" "+_vm._s(_vm.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }